import { NgModule } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { MatSelectModule } from '@angular/material/select'

// import { ClinicService } from '@mmx/shared'
// import { Subject } from 'rxjs'
import { ChipsSelectorModule } from '../chips-selector'
import { ProductsSelectorModule } from './products-selector.module'

@NgModule({
  imports: [
    ChipsSelectorModule,
    MatButtonModule,
    MatDialogModule,
    MatSelectModule,
    ProductsSelectorModule,
  ],
  // providers: [
  //   {
  //     provide: ClinicService,
  //     useValue: {
  //       getProducts: () => new Subject(),
  //     },
  //   },
  // ],
  exports: [ProductsSelectorModule],
})
export class ProductsSelectorTestingModule {}
